<template>
    <div class="">
        <form id="price_list_form" ref="price_list_form" :action="route_form_action" method="post">
            <input v-if="price_list.id != undefined" type="hidden" name="_method" :value="method">
            <input type="hidden" name="_token" :value="csrf_token">
            <input type="hidden" name="tariff_details" :value="json_tariff_details">
            <input type="hidden" name="tariffs" :value="json_tariffs">
            <input type="hidden" name="price_list" :value="json_price_list">
            <input type="hidden" name="no_tariff" :value="json_non_tariff">
            <input type="hidden" name="assing_to_clients_with_copied_price_list" :value="assing_to_clients_with_copied_price_list">
        </form>
        <price-list-form
          ref="price_list_form_component"
          v-model="price_list"
          :edit="isEdit()"
          :countries="countries"
          :superadmin_view="superadmin_view"
          :tariffs="tariffs"
          :price_list_types="price_list_types"
          :mother_price_list="mother_price_list"
          :currencies="currencies"
          :route_price_list_index_json="route_price_list_index_json"
          :read_only="read_only"
          :action="action"
          @addTariffClicked="addTariffClicked"
          @removeTariffClicked="removeTariffClicked"
          />

        <tariff-table
            v-show="!remove_tariff_clicked && (price_list.type == 'mother' || add_tariff_clicked) || (action == 'edit' && !remove_tariff_clicked) || action == 'show'"
            ref="tariff_table_no_tariff_component"
            :services="services_no_tariff"
            :tariffs="tariffs"
            :mode="'no_tariff'"
            :route_tariff_destroy="route_tariff_destroy"
            :csrf_token="csrf_token"
            :tariff_details="tariff_details"
            :validated_form="validated_form"
            :read_only="read_only"
            @nonTariffChange="nonTariffChange"
            :action="action"/>

        <tariff-table
         v-show="!remove_tariff_clicked && (price_list.type=='mother' || add_tariff_clicked) || (action == 'edit' && !remove_tariff_clicked) || action == 'show'"
         ref="tariff_table"
          :services="services"
         :type="price_list.type"
          :tariffs="tariffs"
          :mode="'standard'"
          :route_tariff_destroy="route_tariff_destroy"
          :csrf_token="csrf_token"
          :tariff_details="tariff_details"
          :validated_form="validated_form"
          :read_only="read_only"
          :action="action"/>

        <div class="">
            <div class="ibox">
                <div class="ibox-content">
                    <div class="row" v-if="action == 'copy' && price_list.type=='standard'">
                        <div class="col">
                            <label><input type="checkbox" v-model="assing_to_clients_with_copied_price_list"> Przypisz do klientów z kopiowanym cennikiem</label>
                        </div>
                    </div>
                    <a v-if="showButtons == '1'"
                      :href="previusRoute ? previusRoute : route_price_list_index"
                      class="btn btn-white btn-sm">
                        {{ __('cancel')}}
                    </a>

                    <button
                      v-if="action != 'show'"
                      type="button"
                      form="price_list_form"
                      @click="sendForm()"
                      class="btn btn-primary btn-sm">
                        {{__('save')}}
                    </button>
                    <a
                      v-if="isArchivizable()"
                      :href="route_price_list_archive"
                      class="btn btn-primary btn-sm pull-right">
                        {{ __('archive')}}
                    </a>
                </div>
            </div>
        </div>
        <tariff-modal
          :route_tariff_store="route_tariff_store"
          :csrf_token="csrf_token"
          :tariffs="tariffs_store"
          :services="services"
          :service_template_details="service_template_details"/>
    </div>
</template>

<script>
import Vue from 'vue';
import PriceListForm from '../../components/price-list/priceListForm';
import tariffModal from '../../components/price-list/tariffModal';
import tariffTable from '../../components/price-list/tariffTable';
import mutations from './../../vuex/mutation_types.js';
import Utils from './../../services/Utils.js';
import {mapGetters} from 'vuex';
import { required, minLength, maxLength, between } from 'vuelidate/lib/validators';
import {EventBus} from './EventBus';
import {Money} from "../../services/Money";

export default {
  data : () => ({
      json_tariff_details : '',
      json_tariffs : '',
      json_price_list : '',
      json_non_tariff : '',
      validated_form : false,
      action_route : '',
      price_list : {},
      no_tariff: {},
      bus : new Vue(),
      money: new Money(),
      add_tariff_clicked: false,
      remove_tariff_clicked : false,
      motherNonTariff: {},
      assing_to_clients_with_copied_price_list: false

  }),
  validations : {
        name : {
          required,
          minLength: minLength(6),
          maxLength: maxLength(32)
        }
  },
  components: {
      PriceListForm,
      tariffModal,
      tariffTable,
  },

  props : [
    'method',
    'currencies',
    'countries',
    'price_list_types',
    'csrf_token',
    'services',
    'services_no_tariff',
    'tariffs',
    'price_list_val',
    'tariff_details',
    'route_tariff_store',
    'route_tariff_mass_update',
    'route_tariff_destroy',
    'route_form_action',
    'route_price_list_index',
    'route_price_list_archive',
    'route_price_list_index_json',
    'read_only',
    'service_template_details',
    'action',
    'previusRoute',
    'showButtons',
      'mother_price_list',
      'superadmin_view',
      'prices_not_tariff'

  ],
  computed : {
      ...mapGetters({tariffs_store : 'getTariffsData'}),

  },
  methods : {
      removeTariffClicked(){
          this.add_tariff_clicked = false;
          this.remove_tariff_clicked = true;
          this.$store.commit(mutations.SET_TARIFFS, []);
      },
      addTariffClicked(){
          const _this = this;
          this.add_tariff_clicked = true;
          this.remove_tariff_clicked = false;
          let motherOriginal = this.mother_price_list.find(x => x.id == this.$refs.price_list_form_component.$data.price_list_model.mother_id);
          let mother = JSON.parse(JSON.stringify(motherOriginal));
          if(mother){
              let motherPrices = {};

              Object.keys(mother.price_list_no_tariff).forEach(key => {
                  motherPrices[mother.price_list_no_tariff[key].service_template_detail_id] = mother.price_list_no_tariff[key].price
              });
              this.services_no_tariff.forEach(function (item){
                  item.service_template_details.forEach(function (service){
                      if(!motherPrices.hasOwnProperty(service.id)){
                          motherPrices[service.id] = '';
                      }
                  })
              });
              (this.$refs.tariff_table_no_tariff_component.$refs)['tariff_service'][0].$data.nonTariff = motherPrices;
              this.no_tariff = (this.$refs.tariff_table_no_tariff_component.$refs)['tariff_service'][0].$data.nonTariff
              let exchangeRate = _this.money.toFloat($('.exchange-rate').val())

              this.$refs.tariff_table.$data.price_list_type = 'mother';
              Object.keys(mother.tariff_details).forEach(item=>{
                  mother.tariff_details[item].charge_next_document = _this.money.toFloat(((mother.tariff_details[item].charge_next_document * exchangeRate)).toFixed(2))
                    mother.tariff_details[item].charge_next_user = _this.money.toFloat(((  mother.tariff_details[item].charge_next_user * exchangeRate)).toFixed(2))
                  for (const [key, value] of Object.entries(mother.tariff_details[item].tariffs_details)) {
                      if(mother.tariff_details[item].tariffs_details[key] !== '' && mother.tariff_details[item].tariffs_details[key] !== null &&  mother.tariff_details[item].type != 'free'){
                          mother.tariff_details[item].tariffs_details[key] = _this.money.toFloat(((mother.tariff_details[item].tariffs_details[key] * exchangeRate)).toFixed(2))
                      }

                  }
              })


              this.$store.commit(mutations.SET_TARIFFS, mother.tariff_details);

              setTimeout(() => {
                  $('.exchange_rate_no_tariff').prop('readonly', true)
                  $('.exchange_field').each(function (){
                      let fieldValue = _this.money.toFloat($(this).val())
                      let exchangeRate = _this.money.toFloat($('.exchange-rate').val())

                      let result = (fieldValue * exchangeRate).toFixed(2)
                      $(this).prop('readonly', true)
                  })
              }, 500)


          }
      },
      isEdit() {
          return this.method == 'PUT' ? true : false;
      },
      setPriceList(val) {
        this.price_list = val;
      },
      setCurrencies(input_data) {
      },
      prepareJson() {
        this.json_tariffs = JSON.stringify(this.tariffs_store);
        this.json_tariff_details = JSON.stringify(this.tariff_details);
      },
      isArchived() {
          return this.price_list.status == 'archival';
      },
      isArchivizable() {
          return this.price_list.id != undefined && (this.price_list.type == 'special' || this.price_list.type == 'mother') && this.action=="edit";
      },
      sendForm(e){
          this.prepareJson();
          this.validated_form = true;
          EventBus.$emit('validate_test', this.validated_form);

          let price_list_component = this.$refs.price_list_form_component;
          price_list_component.validateForm();
          let nonTariff = (this.$refs.tariff_table_no_tariff_component.$refs)['tariff_service'][0].$data.nonTariff;
          let validNonTariff  = true;

          for (const [key, value] of Object.entries(nonTariff)) {
              if(this.isEmpty(value)|| value < 0
                  || isNaN(value)){
                  validNonTariff =  false;
              }
          }
          if (this.canSubmit() && validNonTariff && !price_list_component.$v.$invalid) {
            this.updatePriceListCompleteness().then(() => {
                this.$refs.price_list_form.submit();
              }
            );
          }

          return false;
      },
      async updatePriceListCompleteness() {
        this.price_list['complete'] = true;
        this.json_price_list = JSON.stringify(this.price_list);
        this.json_non_tariff = JSON.stringify(this.no_tariff);
      },
      canSubmit(){
        if (this.tariffs_store.length == 0) {
          toastr['error'](this.__('price_list_must_have_min_one_tariff')).css('border', '0px');
            return false;
        }
        for (var i = 0; i < this.tariffs_store.length; i++) {
            let tariff = this.tariffs_store[i];

            if (tariff.type == 'free') {
                let object_has_any_value = false;
                for (const [detail_key, detail_value] of Object.entries(tariff.tariffs_details)) {
                    if(!this.isEmpty(detail_value)) object_has_any_value = true
                }
                if(object_has_any_value == false)
                {
                  toastr['error'](this.__('check_min_one_service_in_free')).css('border', '0px');
                  return false;
                  break;
                }
            }

            for (const [detail_key, detail_value] of Object.entries(tariff.tariffs_details)) {
              if (tariff.type != "free") {
                  if(['pre_paid', 'surcharge', 'subscription'].includes(tariff.type)){
                      var validPrice = parseFloat(detail_value) < 0
                  }
                  else{
                      var validPrice = parseFloat(detail_value) <= 0
                  }
                  if ((detail_value === "" || detail_value == null || validPrice || isNaN(detail_value) || parseFloat(detail_value) > 99999999) &&  !Object.keys(this.no_tariff).includes(detail_key)) {

                      return false;
                      break;
                  }
              }
              if (tariff.type == 'subscription') {

                  if (this.isEmpty(tariff.charge_next_user) || this.isEmpty(tariff.charge_next_document)) {
                    return false;
                  }
              }
            }
        }
        return true;
      },
      isEmpty(value) {
          return Utils.isEmpty(value);
      },
      nonTariffChange(value){
        this.no_tariff = value;
      }
  },
  created: function () {
      if (this.price_list_val != undefined ) {
          this.price_list = this.price_list_val;
      }
  },
  mounted : function () {
      const _this = this;
      this.$store.commit(mutations.SET_CURRENCIES, this.$props.currencies);
      if (this.action !== 'copy' || (this.action == 'copy' && this.price_list.type == 'mother')) {

          if (this.$props.tariffs != undefined) {
              this.$store.commit(mutations.SET_TARIFFS, this.$props.tariffs);
          }
          this.$store.commit(mutations.SET_TARIFF_DETAILS, this.tariff_details);
          if (this.price_list_val != undefined) {
              this.price_list = this.price_list_val;
              this.$refs.tariff_table.$data.price_list_complete = this.price_list_val.complete || !this.price_list_val.has_child;
              if (this.price_list.type == 'mother') {
                  let mother = this.mother_price_list.find(x => x.id == this.price_list.id);
                  if (mother) {
                      let motherPrices = {};
                      if (this.action !== 'copy') {
                          (this.$refs.tariff_table_no_tariff_component.$refs)['tariff_service'][0].$data.isReadonly = true;
                      }


                      Object.keys(mother.price_list_no_tariff).forEach(key => {
                          motherPrices[mother.price_list_no_tariff[key].service_template_detail_id] = mother.price_list_no_tariff[key].price
                      });
                      let noPriceNoTariff = [];
                      this.services_no_tariff.forEach(function (item){
                          item.service_template_details.forEach(function (service){
                              if(!motherPrices.hasOwnProperty(service.id)){
                                  motherPrices[service.id] = '';
                                  noPriceNoTariff.push(service.id)
                              }
                          })
                      });
                      // console.log('motherPrices', motherPrices)
                      (this.$refs.tariff_table_no_tariff_component.$refs)['tariff_service'][0].$data.price_list_complete = this.price_list_val.complete;
                      (this.$refs.tariff_table_no_tariff_component.$refs)['tariff_service'][0].$data.nonTariff = motherPrices;
                      (this.$refs.tariff_table_no_tariff_component.$refs)['tariff_service'][0].$data.noPriceNoTariff = noPriceNoTariff;
                      this.$refs.price_list_form_component.$data.price_list_model.currency_id = 'CSPoints';
                      this.no_tariff = (this.$refs.tariff_table_no_tariff_component.$refs)['tariff_service'][0].$data.nonTariff;
                  }
              } else {
                  let mother = this.mother_price_list.find(x => x.id == this.price_list.mother_id);
                  setTimeout(() => {
                      $('.exchange_rate_no_tariff').prop('readonly', true)
                      $('.exchange_field').prop('readonly', true)
                  }, 500)
                  if (mother) {
                      let motherPrices = {};
                      const _this = this;
                      Object.keys(mother.price_list_no_tariff).forEach(key => {
                          motherPrices[mother.price_list_no_tariff[key].service_template_detail_id] = _this.prices_not_tariff[mother.price_list_no_tariff[key].service_template_detail_id]
                      });
                      this.services_no_tariff.forEach(function (item){
                          item.service_template_details.forEach(function (service){
                              if(!motherPrices.hasOwnProperty(service.id)){
                                  motherPrices[service.id] = '';
                              }
                          })
                      });
                      (this.$refs.tariff_table_no_tariff_component.$refs)['tariff_service'][0].$data.nonTariff = motherPrices;
                      this.no_tariff = (this.$refs.tariff_table_no_tariff_component.$refs)['tariff_service'][0].$data.nonTariff;
                      this.$refs.price_list_form_component.$data.mother_and_exchange_rate_disabled = true;
                  }
              }
          }
      }
  }
}
</script>

<style lang="css" scoped>
  .pull-right {
      float: right;
  }
</style>
